const LED_RED = 21;
const LED_YELLOW = 20;
const LED_GREEN = 16;

import gpio from "gpio";

class LEDs {
  static get schema() {
    return({
      type: "object",
      properties: {
        id: {
          type: "string"
        },
        status: {
          type: "string"
        },
        green: {
          type: "number"
        },
        yellow: {
          type: "number"
        },
        red: {
          type: "number"
        }
      }
    });
  }
  constructor() {
    this.id = "LEDs";
    this.status = "uninitialized";
  }
  initialize() {
    return( new Promise(function(resolve, reject) {

      this.status = "Failed";

      if (gpio.pin[LED_GREEN].exported()) gpio.pin[LED_GREEN].unexport();
      if (gpio.pin[LED_YELLOW].exported()) gpio.pin[LED_YELLOW].unexport();
      if (gpio.pin[LED_RED].exported()) gpio.pin[LED_RED].unexport();

      gpio.pin[LED_GREEN].export();
      gpio.pin[LED_YELLOW].export();
      gpio.pin[LED_RED].export();

      setTimeout(function() {
        gpio.pin[LED_GREEN].direction = 0;
        gpio.pin[LED_GREEN].value = 0;
        gpio.pin[LED_YELLOW].direction = 0;
        gpio.pin[LED_YELLOW].value = 0;
        gpio.pin[LED_RED].direction = 0;
        gpio.pin[LED_RED].value = 0;
        this.__green = 0;
        this.__yellow = 0;
        this.__red = 0;
        this.usbProductName = "leds";
        this.usbSerialNumber = "1";                 
        this.name = "leds";
        this.status = "Ok";    

        resolve(true);
      }.bind(this), 1000);
    }.bind(this)) );
  }
  /* we cache the value of each gpio pins so we dont have to read the gpio pins        */
  /* reading and writing the pins at the same time caused 1sec delay in the event loop */
  /* on long running fermentations (>15day)                                            */
  set green(value) {
    gpio.pin[LED_GREEN].value = value;
    this.__green = value;
  }
  get green() {
    return this.__green;
  }
  set yellow(value) {
    gpio.pin[LED_YELLOW].value = value;
    this.__yellow = value;
  }
  get yellow() {
    return this.__yellow;
  }
  set red(value) {
    gpio.pin[LED_RED].value = value;
    this.__red = value;
  }
  get red() {
    return this.__red;
  }
  update() {
    return( new Promise(function(resolve, reject) {
      resolve(true);
    }.bind(this)) );
  }
  async RM_setRed(value) {
    this.red = value;
  }
  async RM_setYellow(value) {
    this.yellow = value;
  }
  async RM_setGreen(value) {
    this.green = value;
  }  
  toJSON() {
    return {
      name: this.name,            
      usbProductName: this.usbProductName,
      usbSerialNumber: this.usbSerialNumber,      
      status: this.status,      
      id: this.id,      
      green: this.green,
      yellow: this.yellow,
      red: this.red
    };
  }
}

export default LEDs;